import { createSlice } from "@reduxjs/toolkit";
import { fields as initialState } from "../initialState";
import fetchFieldsAction from "../actions/fieldsActions";
import selectAllFieldsSelector from "../selectors/fieldsSelectors";

export const slice = createSlice({
    name: "fields",
    initialState,
    reducers: {
        fetchFields: fetchFieldsAction,
    },
});

// actions
export const { fetchFields } = slice.actions;

// selectors

// getFields
export const selectAllFields = (state) => selectAllFieldsSelector(state);

export default slice.reducer;
